export default "__VITE_ASSET__BGybsRA7__"